import React from 'react'
import { Field, reduxForm, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { 
  Modal, 
  ModalHeader,
	ModalDescription,
	ModalContent,
	ModalActions,
  Button,
  FormGroup,
	Form,
  Icon,
  Segment,
  GridColumn,
	GridRow,
	Grid
} from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { toastWarning } from 'ducks/app'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { getCompanies } from 'ducks/options'
import { createRoleReport, updateRoleReport, clearRoleDataTemp } from 'ducks/report'

const ModalAddUser = (props) => {
  const {
    members,
    companies,
    valueForm,
    change,
    // props
    history,
    onSubmit=null,
    onClose=null
  } = props

  React.useEffect(()=>{
    props.getAllMembers()
    // props.getHrmsMembers()
    props.getCompanies()
    return(()=>{
      props.clearRoleDataTemp()
    })
  },[])

  const submit = () => {
    if(valueForm.username){
      if(valueForm.id){
        props.updateRoleReport(valueForm, history)
      }else{
        props.createRoleReport(valueForm, history)
      }
    }else{
      props.toastWarning('Please select user')
    }
  }

  const onAddCompanyClick = ()=>{
    change(`company[${valueForm.company?.length||0}].delete`,false)
  }

  const onRemoveCompanyClick = (index)=>{
    // r.log(valueForm.company.splice(index,1))
    if(valueForm.company.length==1){
      change(`company`,[])
    }else{
      let clone = JSON.parse(JSON.stringify(valueForm.company))
      clone.splice(index,1)
      change(`company`,clone)
    }
  }

  return (
    <Modal open={true}>
			<ModalHeader>{valueForm?.id?'Edit':'Add'}</ModalHeader>
			<ModalContent image>
				<ModalDescription>
					<Form>
						<FormGroup widths='equal'>
              <Field
                name="username"
                label="User"
                require={true}
                editable={valueForm&&valueForm.id?false:true}
                component={FieldInput}
                allowAdditions={false}
                loading={members.loading}
                options={members.map(m => ({
                  value: m.username.toLowerCase(),
                  text: `${m.firstnameEn} ${m.lastnameEn}`,
                }))}
                type={type.select}
              />
						</FormGroup>
						<FormGroup widths='equal'>
              <Field
                name="active"
                label="Active"
                require={true}
                component={FieldInput}
                type={type.switch}
              />
						</FormGroup>
						<FormGroup widths='equal'>
              <Button positive size='mini' type='button' onClick={()=>onAddCompanyClick()}>Add Company</Button>
						</FormGroup>
            <FormGroup grouped>
              {valueForm.company?.map((x,i)=>{
                return (
                  <FormGroup>
                    <Segment style={{width:'100%'}}>
                      <Grid verticalAlign='middle' columns={2}>
                          <GridRow>
                            {/* <GridColumn>
                            </GridColumn> */}
                            <GridColumn>
                              <Field
                                name={`company[${i}].companyCode`}
                                label="Company"
                                component={FieldInput}
                                allowAdditions={false}
                                loading={companies.loading}
                                options={companies.data}
                                type={type.select}
                              />
                            </GridColumn>
                            <GridColumn width={1}>
                              <Button circular icon='trash alternate' color='red' type='button' onClick={()=>onRemoveCompanyClick(i)}/>
                            </GridColumn>
                          </GridRow>
                          {/* <GridRow>
                            <GridColumn>
                              <Field
                                name={`company[${i}].companyPlant`}
                                label="CompanyPlant"
                                component={FieldInput}
                                type={type.text}
                                placeHolder='1100,1101,1102'
                              />
                            </GridColumn>
                          </GridRow> */}
                      </Grid>
                    </Segment>
                  </FormGroup>
                )
              })}
						</FormGroup>
					</Form>
				</ModalDescription>
			</ModalContent>
			<ModalActions>
        <Button positive onClick={()=>submit()}>Save</Button>
        <Button negative onClick={()=>onClose()}>Close</Button>
			</ModalActions>
		</Modal>
  )
}
const mapStateToProps = (state, props) => {
  let roleDataTemp = state.report.roleDataTemp
  if(!(roleDataTemp.company instanceof Object) && roleDataTemp.company){
    roleDataTemp.company = JSON.parse(roleDataTemp.company)
  }
  return ({
    initialValues: {
      company:[],
      ...roleDataTemp
    },
    valueForm: getFormValues('formReportAddUser')(state)||{},
    members: state.member.members,
    companies: state.options.companies,
  })
}

const mapDispatchToProps = {
  getHrmsMembers,
  createRoleReport, 
  updateRoleReport,
  toastWarning,
  clearRoleDataTemp,
  getCompanies,
  getAllMembers
}

const contForm = reduxForm({
  form: 'formReportAddUser',
  enableReinitialize: true,
})(ModalAddUser)


export default connect(mapStateToProps, mapDispatchToProps)(contForm)